import api from "./../api";

const Publication_API_BASE_URL = "http://localhost:8080/publication";
const Clients_API_BASE_URL = "http://localhost:8080/client";

class DashboardService {
  //Afficher List Publications
  AfficherNumberofPublications() {
    return api.get(Publication_API_BASE_URL + "/count");
  }

  //Afficher List Publications
  AfficherNumberofClients() {
    return api.get(Clients_API_BASE_URL + "/count");
  }
}

export default new DashboardService();
